"use client";
import { createContext, PropsWithChildren, ReactNode, useContext, useState } from "react";
import BottomBar from "./BottomBar";
import { useScrollTrigger } from "@mui/material";
import { Dispatch } from "@reduxjs/toolkit";
import SetStateAction from "react";
type BottomBarState = {
  content?: ReactNode | null;
  attach: boolean;
};
const defaultState: BottomBarState = {
  content: null,
  attach: false,
};
type BottomBarContextType = {
  state: BottomBarState;
  setState: SetStateAction.Dispatch<SetStateAction.SetStateAction<BottomBarState>>;
  resetBottomBar: () => void;
  hide?: boolean;
};
const BottomBarContext = createContext<BottomBarContextType>({
  hide: false,
  state: defaultState,
  resetBottomBar: () => {},
  setState: () => {},
});
export const useBottomBar = () => useContext(BottomBarContext);
export default function BottomBarProvider({ children }: PropsWithChildren) {
  const [state, setState] = useState<BottomBarState>(defaultState);

  const resetBottomBar = () => setState(defaultState);

  return (
    <BottomBarContext.Provider
      value={{
        state,
        setState,
        resetBottomBar,
      }}
    >
      {children}
      <BottomBar />
    </BottomBarContext.Provider>
  );
}
